"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _customProps = require("../../utils/customProps");

var RefComp = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    ref: ref
  }), props.children);
});

var MuiTooltip = function MuiTooltip(_ref) {
  var rootClass = _ref.rootClass,
      title = _ref.title,
      arrow = _ref.arrow,
      placement = _ref.placement,
      children = _ref.children;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    "data-testid": "tooltip",
    className: styles.root,
    placement: placement,
    title: title,
    arrow: arrow
  }, /*#__PURE__*/_react.default.createElement(RefComp, null, children));
};

var _default = MuiTooltip;
exports.default = _default;
MuiTooltip.propTypes = {
  children: _propTypes.default.node.isRequired,

  /** storyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** text for tooltip */
  title: _propTypes.default.string.isRequired,

  /**
   * mui prop: true | false
   * If true, adds an arrow to the tooltip.
   * */
  arrow: _propTypes.default.bool,

  /**
   * mui prop:
   'bottom-end' , 'bottom-start' , 'bottom' , 'left-end' , 'left-start'
   , 'left' , 'right-end' , 'right-start' , 'right' , 'top-end' , 'top-start' , 'top'
   * Tooltip placement.
   * */
  placement: function placement(props, propName, componentName) {
    var validProps = ['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  }
};
MuiTooltip.defaultProps = {
  arrow: false,
  placement: 'bottom',
  rootClass: []
};